import React, { useEffect } from 'react'
import { injectIntl } from 'react-intl'
import styled from 'styled-components'
import { media, ResponsiveContainer } from 'app/assets/styles'
import { H2 } from 'app/common/typography'
import type { IntlShape } from 'react-intl'
import { Layout } from 'app/common/layout'
import { Breadcrumb } from 'app/common/breadcrumb'
import { CookiesManagement } from 'app/common/cookies/management'
import { pageMetadata } from 'shared/store/metadata'
import { useDispatch } from 'react-redux'

type Props = {
    intl: IntlShape
}

const CookiesManagementScreenComponent = (props: Props) => {
    const dispatch = useDispatch()
    const { intl } = props
    const cookiesTitle = intl.formatMessage({
        id: 'cookies.management.title'
    })
    useEffect(() => {
        dispatch(pageMetadata({}))
    }, [])

    return (
        <Layout background="plain" border>
            <StyledContainer>
                <HeadContainer>
                    <CookiesHead>
                        <Breadcrumb
                            breadcrumbArray={[
                                {
                                    title: `\u00A0>\u00A0${cookiesTitle}`
                                }
                            ]}
                        />
                        <StyledH2>{cookiesTitle}</StyledH2>
                    </CookiesHead>
                </HeadContainer>
                <CookiesContainer>
                    <CookiesManagement className="cookies-screen" />
                </CookiesContainer>
            </StyledContainer>
        </Layout>
    )
}

const CookiesContainer = styled.div`
    margin-top: 30px;
`

const StyledContainer = styled(ResponsiveContainer)`
    margin-top: 90px;
    text-align: justify;
    ${media.medium`
        margin-top: 150px;
    `};
`

const HeadContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    align-items: flex-start;
    flex-direction: column;
    ${media.medium`
        justify-content: space-between;
        flex-direction: row;
        width: 100%;
        align-items: center;
    `};
`

const CookiesHead = styled.div``

const StyledH2 = styled(H2)`
    margin: 0;
`

const CookiesManagementScreen = injectIntl(CookiesManagementScreenComponent)

export { CookiesManagementScreen }
